const SHOW_FILTER_DIALOG = (state, payload) => {   
    state.showFilterDialog=payload
};

const MESSAGEBAR_CLEAR = (state) => {
    state.apisuccess.message=''
    state.apisuccess.action=''
    state.apierror.message=''
    state.apierror.action=''
            
};
const MESSAGEBAR_SET_SUCCESS = (state,payload) => {
           
    state.apisuccess.message=payload.message
    state.apisuccess.action=payload.action
};
const MESSAGEBAR_SET_ERROR= (state,payload) => {
           
    state.apierror.message=payload.message
    state.apierror.action=payload.action
};
const MESSAGEBAR_SET = (state, payload) => {
    state.messagebar = payload
};

const SEARCH_UPDATE = (state, search) =>{
    state.search = search
}

const PRE_FILTERED_FIRMEN_SET = (state, payload) => {
    state.preFilteredFirmen = []
    state.preFilteredFirmen = payload
}
        
const PRE_FILTERED_MARKEN_SET = (state, payload) => {
    state.preFilteredMarken = []
    state.preFilteredMarken = payload
}

const WARENGRUPPEN_SET = (state, payload) =>{
    state.warengruppen = payload
}
const TYPES_SET = (state, payload) =>{
    state.types = payload
}
export default {  
  SHOW_FILTER_DIALOG,
  MESSAGEBAR_CLEAR,
  MESSAGEBAR_SET_SUCCESS,
  MESSAGEBAR_SET_ERROR,
  MESSAGEBAR_SET,
  PRE_FILTERED_FIRMEN_SET,
  PRE_FILTERED_MARKEN_SET,
  SEARCH_UPDATE,
  WARENGRUPPEN_SET,
  TYPES_SET,
};